import React from "react";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";
import { faEnvelopeOpen } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CredentialService from "../../../services/CredentialService";
import { useStyles } from "./styles";
import apiClient from "../../../auth/apiClient";
import { useEnqueueSnackbar } from "../../../hooks/useEnqueueSnackbar";
import { isEmpty } from "lodash";
import clsx from "clsx";

// TODO: for now, emailing exists on the credential-service
// will need to move this to routine-service once it is up
const credentialService = new CredentialService(apiClient);

const CredentialEmailButton = ({
  to,
  qrCode,
  toAddressMessage,
  facilityID,
  accessHolderID,
  isDisabled
}) => {

  const enqueueSnackbar = useEnqueueSnackbar();

  const handleSendEmail = async () => {
    if (!to || isEmpty(to)) {
      enqueueSnackbar(toAddressMessage, {
        variant: "warning", tag: "missingToAddress"
      });
      return;
    }
    const emailRequest = {
      FacilityID: facilityID,
      AccessHolderID: accessHolderID,
      QrCode: qrCode,
    };
    try {
      await credentialService.SendAccessHolderCredential(emailRequest);
      enqueueSnackbar("Successfully sent email", { variant: "success" });
    } catch {
      enqueueSnackbar("Failed to send email", { variant: "error", tag: "emailFailure" });
    }
  };

  return (
    <Button
      className={clsx("email-btn")}
      variant="contained"
      color="primary"
      size="small"
      aria-label={"email-button"}
      title="E-Mail Credential"
      onClick={handleSendEmail}
      data-testid="credentialEmailButton"
      disabled={isDisabled}
    >
      <FontAwesomeIcon
        icon={faEnvelopeOpen}
        className={clsx("font-awesome-icon")}
        size="lg"
      />
    </Button>
  );
};

CredentialEmailButton.defaultProps = {
  toAddressMessage: "No 'To' address provided",
  isDisabled: false,
};

CredentialEmailButton.propTypes = {
  to: PropTypes.string.isRequired,
  facilityID: PropTypes.string.isRequired,
  accessHolderID: PropTypes.string.isRequired,
  qrCode: PropTypes.string.isRequired,
  toAddressMessage: PropTypes.string,
  isDisabled: PropTypes.bool
};

export default CredentialEmailButton;
